import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../../../../../context/LanguageContext';
import { SLIDING_TEXT_SERVICE_ITEMS } from '../../../../../data/types/ServiceTypes';
import '../style/sliding-text.css';
import { initializeSlidingText } from '../script/sliding-text';

const SlidingText: React.FC = () => {
    const { t } = useLanguage();
    const containerRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (containerRef.current) {
            initializeSlidingText(containerRef.current);
        }
    }, []);

    return (
        <section className="sliding-text" ref={containerRef}>
            <div className="sliding-text__inner" style={{ backgroundColor: '#d90202' }}>
                <ul className="sliding-text__list marquee_mode-2 list-unstyled">
                    {/* First set of items */}
                    {SLIDING_TEXT_SERVICE_ITEMS.map((item, index) => (
                        <li key={`first-${index}`}>
                            <div className="icon">
                                <span className={item.iconClass}></span>
                            </div>
                            <p>{(t as any).SERVICES[item.translationKey]}</p>
                        </li>
                    ))}
                    {/* Duplicate set for seamless infinite loop */}
                    {SLIDING_TEXT_SERVICE_ITEMS.map((item, index) => (
                        <li key={`second-${index}`}>
                            <div className="icon">
                                <span className={item.iconClass}></span>
                            </div>
                            <p>{(t as any).SERVICES[item.translationKey]}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default SlidingText;

